import React, { Component } from "react";
import {
  company,
  profile,
  GET,
  POST,
  PUT,
  alert,
  loading,
  t
} from "./CustomComponent.js";
import Language from "../components/Language.js";
import { Navbar, Nav } from "react-bootstrap";
import SidebarBrand from "./SidebarBrand.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import AlertBell from "./AlertBell.js";
import { effectivePermissions } from "../utils/portalAccess.js";
import { clearStorageKeepLang } from "../utils/backendMessage";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pending_attendance: 0,
      total_balance_available: 0,
      total_balance_thb: 0,
      total_balance_lak: 0,
      dropdown: "",
      array_link: [...this.filterMenu(profile)],
      user_profile: profile,
      modal_news: false,
      announce_datetime: "",
      announce_duration: 0,
      announce_detail: "",
      alert_badges: null,
      notif_rows: [],
      notif_unread: 0,
      notif_loading: false,
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  sidebar_ref = React.createRef();
  sidebar_scroll_key = "sidebar_scroll_admin";

  componentDidMount = async () => {
    // โหลดโปรไฟล์
    await this.GetProfile();

    this.GetPendingAttendance();
    // ป้ายแจ้งเตือน + กระดิ่ง: โหลดตอนเข้าหน้า (เปลี่ยนหน้า = โหลดใหม่) และรีเฟรชทุก 5 นาที
    this.GetAlertBadges();
    this.alert_timer = setInterval(this.GetAlertBadges, 5 * 60 * 1000);

    // ตรวจสอบการล็อกอิน
    if (!profile) {
      window.location.href = "/";
      return;
    }

      // คืนตำแหน่ง scroll ของเมนูด้านซ้าย ให้เห็นเมนูที่เลือกอยู่
      this.restoreSidebarScroll();
  };
  componentWillUnmount() {
    clearInterval(this.alert_timer);
  }
  silentOptions = { silent: true };
  // ป้ายแดงเมนู ประกัน/ไส้กรอง/PM + จำนวนแจ้งเตือนที่ยังไม่อ่าน (ไม่เด้ง alert ถ้าโหลดไม่ได้)
  GetAlertBadges = async () => {
    // เมนู/กระดิ่งแจ้งเตือนถูกซ่อนไว้ก่อน (global.ALERT_PAGES_MENU_HIDDEN) ไม่ต้องโหลดตัวเลข
    if (global.ALERT_PAGES_MENU_HIDDEN || !localStorage.getItem("cm-acc-tk")) return;
    const result = await GET("admin/alert-badges", null, true, this.silentOptions);
    if (result?.status && result.data) {
      this.setState({
        alert_badges: result.data,
        notif_unread: result.data.notifications?.unread || 0,
      });
    }
  };
  GetNotifications = async () => {
    this.setState({ notif_loading: true });
    const result = await GET("admin/notifications", { limit: 20 }, true, this.silentOptions);
    if (result?.status) {
      this.setState({
        notif_rows: result.data?.rows || [],
        notif_unread: result.data?.unread_count ?? this.state.notif_unread,
      });
    }
    this.setState({ notif_loading: false });
  };
  ReadNotification = async (item) => {
    const result = await PUT(`admin/notifications/${item.uid}/read`, {});
    if (result?.status) {
      this.setState((s) => ({
        notif_rows: s.notif_rows.map((r) => (r.uid === item.uid ? { ...r, is_read: true } : r)),
        notif_unread: Math.max(0, s.notif_unread - (item.is_read ? 0 : 1)),
      }));
    }
  };
  ReadAllNotifications = async () => {
    const result = await PUT("admin/notifications/read-all", {});
    if (result?.status) {
      this.setState((s) => ({
        notif_rows: s.notif_rows.map((r) => ({ ...r, is_read: true })),
        notif_unread: 0,
      }));
    }
  };
  // จำนวนด่วนของเมนูแจ้งเตือน (null = ซ่อน: ไม่มีสิทธิ์ / 0)
  alertBadgeCount = (link) => {
    const b = this.state.alert_badges;
    const group = { "/ad/warranty-expiry": b?.warranty, "/ad/filter-alert": b?.filter, "/ad/pm-alert": b?.pm }[link];
    if (!group || group.visible === false || !(group.urgent > 0)) return 0;
    return group.urgent;
  };
  // badge จำนวนคำขอแก้ไขเวลาที่รออนุมัติ ข้างเมนู "ลงเวลาเข้า-ออก" (เฉพาะผู้มีสิทธิ์ attendance.read)
  GetPendingAttendance = async () => {
    let latest = null;
    try {
      latest = JSON.parse(localStorage.getItem("cm-profile") || "null");
    } catch {
      latest = null;
    }
    const allowed =
      ["super_user", "admin-company"].includes(latest?.user_type) ||
      (latest?.role?.permission || []).includes("attendance.read");
    if (!allowed) return;
    const result = await GET("admin/attendance/corrections", { status: "pending" }, true, {
      skipAccessDeniedAlert: true,
      skipUserVerificationAlert: true,
    });
    if (result?.status) this.setState({ pending_attendance: (result.data?.web_pending_count ?? result.data?.pending_count) || 0 });
  };
  GetProfile = async () => {
    const result = await GET("admin/users/profile", null, false);
    if (result?.status) {
      localStorage.setItem("cm-profile", JSON.stringify(result.data));
      this.setState({
        user_profile: result.data,
        array_link: [...this.filterMenu(result.data)],
      });
      this.permissionSetting();
    }
  };
  async componentDidUpdate() {
    this.permissionSetting();
    this.restoreSidebarScroll();
  }

  handleSidebarScroll = (e) => {
    sessionStorage.setItem(this.sidebar_scroll_key, e.target.scrollTop);
  };

  restoreSidebarScroll = () => {
    if (this.sidebar_restored || this.sidebar_restoring) return;
    const el = this.sidebar_ref.current;
    // ยังไม่ render หรือถูกซ่อนอยู่ (จอเล็ก) ให้ข้ามไปก่อน
    if (!el || !el.clientHeight) return;
    this.sidebar_restoring = true;

    requestAnimationFrame(() => {
      this.sidebar_restoring = false;
      // เมนูยังสั้นกว่าจอ (ยัง render ไม่ครบ) ไม่ต้องเลื่อน รอรอบถัดไป
      if (el.scrollHeight <= el.clientHeight) return;
      this.sidebar_restored = true;

      const saved = Number(sessionStorage.getItem(this.sidebar_scroll_key));
      if (saved > 0) {
        el.scrollTop = saved;
        return;
      }
      // ไม่มีค่าที่จำไว้ ให้เลื่อนเมนูที่ active มากลางจอ
      const active = el.querySelector(".nav-link-sidebar.active");
      if (!active) return;
      const top =
        active.getBoundingClientRect().top -
        el.getBoundingClientRect().top +
        el.scrollTop;
      el.scrollTop = Math.max(0, top - el.clientHeight / 2 + active.offsetHeight / 2);
    });
  };
  filterMenu = (profile) => {
    // พอร์ทัลที่ประเภทผู้ใช้ "ดูอย่างเดียว" เหลือเฉพาะ .read (utils/portalAccess)
    let perms = effectivePermissions(profile);

    // perms.push("settings.read");
    // เมนูที่คุมด้วยประเภทผู้ใช้ (ตั้งค่าระบบ) ดูแค่ประเภท ไม่ดู permission / เมนูอื่นดู permission ตามเดิม
    // hidden: true = ไม่โชว์ในเมนู (เช่นหน้าแจ้งเตือนที่ซ่อนไว้ก่อน / หน้าย่อยที่เข้าจากลิงก์) แต่ route + permission ยังอยู่
    const menu = global.menu_admin?.filter(
      (item) =>
        !item.hidden &&
        (!item.link ||
        !item.permission ||
        global.canAccessMenuItem(item, perms, profile)),
    );
    return menu
      .reduce((acc, item) => {
        if (item.title && acc.at(-1)?.title) return acc;
        acc.push(item);
        return acc;
      }, [])
      .filter((_, i, arr) => !(i === arr.length - 1 && arr[i].title));
  };
  permissionSetting = () => {
    // ปุ่มที่ติด className เป็น permission key จะถูกถอดออก ถ้าพอร์ทัลนี้ดูอย่างเดียว key ที่ไม่ใช่ .read ถูกตัดไปแล้ว
    const role = new Set(effectivePermissions(this.state.user_profile));
    global.permission.forEach((perm) => {
      if (!role.has(perm)) {
        [...document.getElementsByClassName(perm)].forEach((el) => el.remove());
      }
    });
  };
  componentMenu = () => {
    const classNameBTN =
      "nav-link-sidebar d-flex align-items-center py-2 px-3 mb-1 rounded-lg text-decoration-none";
    const classNameICON = "icon wpx-24 text-center me-3";
    // path ปัจจุบัน (ตัด / ท้าย และ query ออก) ใช้เทียบว่าตอนนี้อยู่เมนูไหน
    const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
    const currentType = new URLSearchParams(window.location.search).get("type");
    // เลือก link ที่ match ยาวที่สุด เพื่อให้หน้าย่อย (เช่น /cs/work-requests/create)
    // ยัง highlight เมนูแม่อยู่ และไม่ชนกับเมนูที่ชื่อขึ้นต้นเหมือนกัน (/wh/stock vs /wh/stock-claim)
    const activeLink = this.state.array_link
      .filter((menu) => menu.link)
      .map((menu) => menu.link.replace(/\/+$/, ""))
      .filter((link) => currentPath === link || currentPath.startsWith(`${link}/`))
      .sort((a, b) => b.length - a.length)[0];
    const linkItem = (href, icon, label, isActive, extra = null) => (
      <a
        href={href}
        key={href}
        aria-current={isActive ? "page" : undefined}
        className={`${classNameBTN} ${isActive ? "active" : ""}`}
      >
        <span className={classNameICON}>
          {icon}
        </span>
        <span className="flex-grow-1">{t(label)}</span>
        {extra}
        {}
      </a>
    );

    const { array_link, user_profile } = this.state;

    return (
      <div className="sidebar-menu">
        {array_link.map((item, i) => {
          if (!item.title && !item.link){
            return null;
          }
          if (item.title)
            return (
              <div className="sidebar-section-title text-uppercase text-secondary small fw-semibold px-3 py-2 mt-1 mb-1" key={`title-${i}`}>
                {t(item.title)}
              </div>
            );
          const params = [`type=${item.type}`]?.filter(Boolean).join("&");
          const href = `${item.link}${
            item.type || item.country ? "?" + params : ""
          }`;
          // เมนูที่ active = link ตรงกับ path ปัจจุบัน และถ้าเมนูมี type ต้องตรงกับ ?type= ด้วย
          const isActive =
            item.link.replace(/\/+$/, "") === activeLink &&
            (item.type == null || String(item.type) === currentType);
          return linkItem(
            `${href}`,
            item.icon,
            item.name,
            isActive,
            item.link === "/ad/attendance" && this.state.pending_attendance > 0 ? (
              <span className="badge rounded-pill ms-2" style={{ backgroundColor: "#FDECEC", color: "#D64545" }}>
                {this.state.pending_attendance}
              </span>
            ) : this.alertBadgeCount(item.link) > 0 ? (
              <span
                className="badge rounded-pill ms-2"
                style={{ backgroundColor: "#D64545", color: "#fff" }}
                aria-label={`${this.alertBadgeCount(item.link)}`}
              >
                {this.alertBadgeCount(item.link)}
              </span>
            ) : (
              item.component
            ),
          );
        })}

        {/* <hr className="my-3 mx-3 sidebar-divider" /> */}

        <div className="d-block d-xl-none px-2">
          <button
            className={`${classNameBTN} w-100 text-danger border-0 bg-transparent`}
            onClick={async () => {
              this.Logout();
            }}
          >
            <span className={classNameICON}>
              {"\uf2f5"}
            </span>
            <span>{["super_user","admin-company"].includes(user_profile?.user_type) ? t("back_to_portal") : t("logout")}</span>
          </button>
        </div>
        <div className="d-none d-xl-block hpx-100"></div>
      </div>
    );
  };
  Logout = async () => {
    const {user_profile} = this.state;
    if(["super_user","admin-company"].includes(user_profile?.user_type)){
      window.location.href = "/portal";
    }else{
      let module = [];

    if((user_profile.role?.permission).includes("dashboard-admin.read")){
        module.push("admin");
    }
    if((user_profile.role?.permission).includes("dashboard-customer.read")){
        module.push("customer");
    }
    if((user_profile.role?.permission).includes("dashboard-warehouse.read")){
        module.push("warehouse");
    }
    if(module.length >1){
      window.location.href = "/portal";
    }
    if (
       await alert(
              "",
              "warning",
              t("confirm"),
              t("logout_ask"),
              t("logout"),
              t("cancel"),
            )
    ) {
      loading(true);
      let result = await POST("auth/logout");
      if (result?.status) {
        clearStorageKeepLang();
        window.location.href = "/";
      }
      loading(false);
    }
    }
  };

  render() {
    const {
      user_profile,
    } = this.state;
    return (
      <div className="hpx-50">
        <Navbar
          className="px-3 px-xl-4 bg-white position-fixed w-100"
          style={{ zIndex: 1020, border: "0", borderBottom: "1px solid var(--bs-gray-2)" }}
          expand="xl"
        >
          <Navbar.Brand href={`/ad/dashboard`} className="fw-bold text-dark d-flex">
            <div className="position-relative">
              <img
                alt="logo"
                src={LOGO}
                height={25}
                style={{ objectFit: "contain" }}
                className="pointer d-none d-sm-block"
                onClick={() => {
                  window.location.href = `/ad/dashboard`;
                }}
              />
              <img
                alt="logo"
                src={LOGO}
                height={30}
                style={{ objectFit: "contain" }}
                className="pointer d-block d-sm-none"
                onClick={() => {
                  window.location.href = `/ad/dashboard`;
                }}
              />
              <span className="position-absolute d-none d-sm-block" style={{ right: 8, bottom: -4, fontSize: 10, color: "#dabb55" }}>
                {user_profile?.user_type?.replaceAll("_", "")} v{" "}
                {global.version}
              </span>
            </div>
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            {/* กระดิ่งแจ้งเตือนผูกกับหน้าแจ้งเตือนประกัน/ไส้กรอง/PM ที่ซ่อนไว้ก่อน (global.ALERT_PAGES_MENU_HIDDEN) */}
            {!global.ALERT_PAGES_MENU_HIDDEN && (
            <AlertBell
                className="d-xl-none"
                unread={this.state.notif_unread}
                items={this.state.notif_rows}
                loading={this.state.notif_loading}
                onOpen={this.GetNotifications}
                onRead={this.ReadNotification}
                onReadAll={this.ReadAllNotifications}
              />
            )}
            <Navbar.Toggle className="border-0" aria-controls="basic-navbar-nav"/>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <div className="d-none d-xl-flex align-items-center">
                {!global.ALERT_PAGES_MENU_HIDDEN && (
                <AlertBell
                className="me-2"
                unread={this.state.notif_unread}
                items={this.state.notif_rows}
                loading={this.state.notif_loading}
                onOpen={this.GetNotifications}
                onRead={this.ReadNotification}
                onReadAll={this.ReadAllNotifications}
              />
                )}
                 <Language/>
                <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: 'var(--bs-gray-2)' }}/>
                <div className="d-none d-xl-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                  <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: '0.75rem' }}>
                    {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                  </span>
                  <div className="pe-2">
                    <div className="text-14 fw-semibold text-dark">
                      {user_profile?.full_name || "Username"}
                    </div>
                    <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                      {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-xl-none mb-5 pt-4 overflow-scroll" style={{ height: "80vh" }}>
                {this.componentMenu()}
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div
          className="position-fixed wpx-260 sidebar-dark overflow-scroll d-none d-xl-block"
          ref={this.sidebar_ref}
          onScroll={this.handleSidebarScroll}
          style={{
            zIndex: 1021,
            height: "100vh",
            border: "0",
          }}
        >
          <SidebarBrand href="/ad/dashboard" company={company} />
          <div className="px-3 mb-5" style={{ marginTop: 64 }}>
            {this.componentMenu()}
          </div>
          <div
            className="position-fixed sidebar-dark pb-3 px-3 wpx-260"
            style={{
              bottom: 0,
              border: "0",
              borderTop: "1px solid #334155",
              paddingTop: "12px",
            }}
          >
            <div className="d-flex align-items-center text-start w-100 p-2 rounded-lg" style={{ backgroundColor: '#334155' }}>
              <span className="user-avatar me-2 wpx-36 hpx-35 d-flex align-items-center justify-content-center" style={{ fontSize: '0.8rem' }}>
                {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
              </span>
              <div className="flex-grow-1 overflow-hidden">
                <div className="text-14 fw-semibold text-white text-truncate">
                  {user_profile?.full_name || "Username"}
                </div>
                <div className="text-12 text-truncate" style={{ marginTop: -2, color: '#94a3b8' }}>
                  {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                </div>
              </div>
              <button
                className="btn btn-sm border-0 p-2 text-white"
                style={{ opacity: 0.7 }}
                onClick={() => {
                  window.location.href = "/change-password?from=menu";
                }}
                title={t("change_password_title")}
              >
                <span className="icon">{"\uf084"}</span>
              </button>
              <button
                className="btn btn-sm border-0 p-2 text-white"
                style={{ opacity: 0.7 }}
                onClick={() => {
                  this.Logout();
                }}
                title={["super_user","admin-company"].includes(user_profile?.user_type) ? t("back_to_portal") : t("logout")}
              >
                <span className="icon">{"\uf08b"}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
